module.exports = __webpack_public_path__ + "img/trash-2.28784754.svg";